import moment from 'moment';
import _ from 'lodash';

const applyVideoTimestamps = (events, recordingStart, recordingEnd, videoDuration) => {
  const result = _.map(events, (event) => {
    const eventTimestamp = event.date.getTime();

    const playbackPosPct =
      (((eventTimestamp - recordingStart) * 100) / (recordingEnd - recordingStart));

    const playbackPosInMS = videoDuration * (playbackPosPct / 100);
    const updatedEvent = {
      ...event,
      playbackPosInMS,
      playbackPosPct,
    };
    return updatedEvent;
  });

  return result;
};

export default {
  currentId(state) { return state.currentId; },
  current(state, getters) {
    if (!getters.currentId) return null;
    return _.find(state.allRecordings, { _id: getters.currentId });
  },
  fetched(state) {
    return state.status.recording === 'Fetched' && state.status.events === 'Fetched';
  },
  allRecordingsFetched(state) {
    return state.status.allRecordings === 'Fetched';
  },
  issues(state, getters, rootState) {
    if (getters.current && rootState.issues.data) {
      return applyVideoTimestamps(
        _.chain(rootState.issues.data)
          .filter({ recordingId: getters.current._id })
          .map(iss => ({
            ...iss,
            date: new Date(iss.clientStart || iss.created),
          }))
          .value(),
        state.recordingStart, state.recordingEnd, state.recordingDuration);
    }
    return null;
  },
  events(state, getters) {
    if (getters.current && state.events) {
      return applyVideoTimestamps(
        _.map(state.events, evt => ({
          ...evt,
          date: new Date(evt.clientTimestamp),
        })),
        state.recordingStart, state.recordingEnd, state.recordingDuration);
    }
    return null;
  },
  consoleObjects(state, getters) {
    if (getters.current && getters.issues && getters.events) {
      // Every resulting consoleObject needs an _id
      const issues = getters.issues;
      const events = getters.events;
      const unsortedObjects = Object.assign({}, issues, events);
      return _.sortBy(unsortedObjects, ['date']);
    }
    return null;
  },
  currentConsoleObjectIndex(state, getters) {
    if (getters.current && getters.issues && getters.events) {
      const consoleObjects = getters.consoleObjects;
      const videoTimeInMS = getters.videoTimeInMS;
      // Find the first consoleObject that is in the future, then return the previous index number (the last current consoleObject)
      for (let i = 0, { length } = consoleObjects; i < length; i++) {
        if (consoleObjects[i].date.getTime() > videoTimeInMS) {
          return i - 1;
        }
      }
    }
    return null;
  },
  videoTimeInMS(state) {
    if (state.playbackPosInMS) {
      return state.recordingStart + state.playbackPosInMS;
    }
    return state.recordingStart;
  },
  formattedCurrentVideoTime(state) {
    const currentPosition = state.playbackPosInMS;
    const formatTime = moment(currentPosition).format('mm:ss');
    return formatTime;
  },
  formattedVideoDuration(state) {
    const duration = state.recordingDuration;
    const formatTime = moment(duration).format('mm:ss');
    return formatTime;
  },
  seekBarPercent(state) {
    const currentTime = state.playbackPosInMS;
    const duration = state.recordingDuration;
    const seekBarPercent = (currentTime / duration) * 100;
    return seekBarPercent;
  },
  currentIssue({ currentIssueId }, getters, rootState) {
    const issues = rootState.issues.data;
    if (!currentIssueId || !issues) return null;
    return _.find(issues, { _id: currentIssueId });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/recordings/getters.js